<template>
    <auth-layout>
        <div name="back-button" class="d-none d-lg-block">
            <a :href="route('login')" class="auth-back-btn">
                <i class="tio-back-ui"></i>
            </a>
        </div>
        <div class="auth-form-container">
            <jet-validation-errors class="mb-4" />

            <h3>Hai dimenticato la password?</h3>
            <p>Inviaci la tua email e riceverai le istruzioni per reimpostare la password.</p>

            <form @submit.prevent="submit" class="mt-5">
                <div class="auth-form-group">
                    <jet-input id="email" type="email" class="mt-1 auth-form-control block w-full" placeholder="Email" v-model="form.email" required autofocus />
                </div>

                <div class="auth-form-group">
                    <button type="submit" class="btn btn-primary" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">Invia</button>
                </div>                
            </form>

            <div v-if="status" class="alert alert-success mt-4">
                <p class="mb-0">Email inviata correttamente. Contolla la posta!</p>
            </div>            
        </div>
    </auth-layout>
</template>

<script>
    import AuthLayout from '@/Layouts/AuthLayout'
    import JetButton from '@/Jetstream/Button'
    import JetInput from '@/Jetstream/Input'
    import JetLabel from '@/Jetstream/Label'
    import JetValidationErrors from '@/Jetstream/ValidationErrors'

    export default {
        components: {
            AuthLayout,
            JetButton,
            JetInput,
            JetLabel,
            JetValidationErrors
        },

        props: {
            status: String
        },

        data() {
            return {
                form: this.$inertia.form({
                    email: ''
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('password.email'))
            }
        }
    }
</script>
